import { Stack } from "@mui/material";

import Context from "./context";
import ForceApiCard from "./ForceApiCard/ForceApiCard";
import EntitiesListDialog from "./PolicyConfigCard/EntitiesListDialog/EntitiesListDialog";
import PolicyConfigCard from "./PolicyConfigCard/PolicyConfigCard";
import useAppConfigActionsStore from "./store";

// ----------------------------------------------------------------------

export const PolicyConfiguration = () => {
	const [state, actions] = useAppConfigActionsStore();

	return (
		<Context.Provider value={{ state, actions }}>
			<Stack gap={3}>
				<ForceApiCard />
				<PolicyConfigCard />
			</Stack>
			<EntitiesListDialog />
		</Context.Provider>
	);
};

export default PolicyConfiguration;
